// extracted by mini-css-extract-plugin
module.exports = {"table":"index_table_2G7ZS"};